<template>
  <div class="container-fluid mt-3">
    <h4>Regeln</h4>
    <b-tabs content-class="mt-3">
      <b-tab title="Auftragsprüfung">
        <RuleOrderCheck/>
      </b-tab>
      <b-tab title="Belegnummern">
        <RuleDocNumber/>
      </b-tab>
      <b-tab title="Preisberechnung">
        <div class="wrapper">
          <RulePriceCalc/>
        </div>
      </b-tab>
      <b-tab title="Warenkorb">
        <div class="wrapper">
          <RuleAddCart/>
        </div>
      </b-tab>
      <b-tab title="Daten-Modifikation">
        <RuleDataModulator/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import RuleOrderCheck from '@/components/digitalfirm/RuleOrderCheck.vue'
import RulePriceCalc from '@/components/digitalfirm/RulePriceCalc.vue'
import RuleAddCart from '@/components/digitalfirm/RuleAddCart.vue'
import RuleDocNumber from '@/components/digitalfirm/RuleDocNumber.vue'
import RuleDataModulator from '@/components/digitalfirm/RuleDataModulator.vue'

export default {
  name: 'RulesEditor',
  components: {
    RuleAddCart,
    RulePriceCalc,
    RuleOrderCheck,
    RuleDocNumber,
    RuleDataModulator
  }
}
</script>
